module.exports = __webpack_public_path__ + "img/ajans-press-courier-ad-03.6d0de970.jpg";